import ArrowLargeIcon from "./arrow-large-icon";

export default ArrowLargeIcon;